import Requests from './list/requests'
import ToPay from './list/to-pay'
import Confirmed from './list/confirmed'
import Archive from './list/archive'
import ViewProposal from './view-proposal'

export default [
  {
    value: 'requests',
    title: 'Requests',
    description:
      'From your Requests dashboard you can track the status of all the requests you have made.',
    component: Requests,
    iconSeparator: 'fa fa-angle-right'
  },
  {
    value: 'to-pay',
    title: 'To Pay',
    description:
      'Here you can keep track of all Proposals sent to you by a Space. Need something amended? No worries - simply message the Space and ask them to update the Proposal.',
    component: ToPay,
    iconSeparator: 'fa fa-angle-right'
  },
  {
    value: 'confirmed',
    title: 'Confirmed',
    description:
      'Here you can see and manage all your confirmed and paid bookings. Feel free to continue to Message with the Space directly for any last minute details! Don&apos;t forget to show up on time!',
    component: Confirmed,
    iconSeparator: 'fa fa-angle-right'
  },
  {
    value: 'archive',
    title: 'Archive',
    description:
      'When you cancel or archive a request, it will appear here for you to have a record of.',
    component: Archive,
  },
]

export const switchableComponentObj = [
  { value: 'view-proposal', component: ViewProposal },
]

export const requestsInstruction = [
  {
    title: 'SPACE ACCEPTS YOUR REQUEST',
    description:
    `To get things started, the Space will need to accept your request so you can begin messaging. Don't worry if they Decline or Cancel your request - there are thousands of more spaces to chose from!`,
  },
  {
    title: 'MESSAGE DIRECTLY WITH THE SPACE',
    description:
    `Once your requested has been Accepted, you will be able to Message directly with the Space on the platform. Make sure to communicate all your needs for your space.`,
  },
  {
    title: 'RECEIVE A PROPOSAL',
    description:
    `Once terms have been discussed, the Space will send you a Proposal with a payment link for you to checkout. This will move the request to the next tab labelled To Pay.`,
  },
]

export const toPayInstruction = [
  {
    title: 'REVIEW THE PROPOSAL',
    description:
    `Check all the details of the proposal to ensure it meets what you have discussed. Ifany issues simple let the Space know with a Message!`,
  },
  {
    title: 'CHECKOUT',
    description:
    `You can pay directly from the dashboard via the Pay Now links, or within the Proposal itself. You will be taken to a checkout page where you can select your preferred payment method.`,
  },
  {
    title: 'RECEIVE A PROPOSAL',
    description:
    `Once terms have been discussed, the Space will send you a Proposal with a payment link for you to checkout. This will move the request to the next tab labelled To Pay.`,
  },
]

export const requestCancelReasons = [
  'The space cannot accommodate my request',
  'The space was unresponsive',
  'I have found another space',
]

export const statusSchema = {
  accepted: 'bg-green-100 text-action-success',
  expired: 'bg-gray-100 text-primary-lightgray',
  pending: 'bg-secondary-lightorange text-primary-orange',
  declined: 'bg-red-100 text-action-danger',
  cancelledByClient: 'bg-red-100 text-action-danger',
  cancelledBySpace: 'bg-red-100 text-action-danger',
  declinedBySpace: 'bg-red-100 text-action-danger',
  pendingPayment: 'bg-secondary-lightorange text-primary-orange',
  paid: 'bg-green-100 text-action-success',
  pendingBankDeposit: 'bg-secondary-lightorange text-primary-orange',
  booked: 'bg-secondary-lightorange text-primary-orange',
  confirmed: 'bg-green-100 text-action-success',
  cancelled: 'bg-red-100 text-action-danger',
  proposalSent: 'bg-green-100 text-action-success',
  waitingBankDeposit: 'bg-secondary-lightorange text-primary-orange',
}
